import {styled} from "@mui/material/styles"

export const Image = styled("img")<{isFirstElement: boolean}>`
    margin: ${({isFirstElement}) => (isFirstElement ? `1.5rem 1rem 0 0.24rem` : `0 1rem 0 0.25rem`)};
`
